import { render, staticRenderFns } from "./StudentDashboard.vue?vue&type=template&id=693a958a&scoped=true&"
import script from "./StudentDashboard.vue?vue&type=script&lang=js&"
export * from "./StudentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StudentDashboard.vue?vue&type=style&index=0&id=693a958a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a958a",
  null
  
)

export default component.exports